import '../scss/main.scss';

$(document).ready(function() {
    // スムーススクロール
    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();

        const target = $($(this).attr('href'));

        if (target.length) {
        $('html, body').animate({
            scrollTop: target.offset().top
        }, 600, 'swing');
        }
    });

    // hamburger menu
    $('.hamburger').on('click', function() {
        $('.hd_nav').toggleClass('active');
        $('.hamburger').toggleClass('active');
        $('body').toggleClass('no-scroll');
    });

    // header scroll
    const $header = $('header');

    window.addEventListener('scroll', function() {
        let scrollPos = window.scrollY || document.documentElement.scrollTop;
        if (scrollPos > 100) {
            $header.addClass('scrolled');
        } else {
            $header.removeClass('scrolled');
        }
    }, { passive: true });

    $(window).on('scroll', function() {
        // スクロールアニメーションの追加
        $('.flip-in, .under-in, .roll-in').each(function() {
          var elementTop = $(this).offset().top;
          var viewportBottom = $(window).scrollTop() + $(window).height();
          if (elementTop < viewportBottom - 200) {
              $(this).addClass('visible');
          }
        });
    });

    // モバイル用
    window.addEventListener('touchmove', function() {
        // 必要に応じて処理を追加
    }, { passive: true });
});